// Copyright 1999-2020. Plesk International GmbH. All rights reserved.

export { default } from './Preferences';
export { default as OverlayAdapter } from './OverlayAdapter';



// WEBPACK FOOTER //
// ./app/cookie-policy/Preferences/index.js